<template>
    <div class="tw:hidden tw:xl:flex tw:items-center tw:gap-x-4" />
</template>

<script>
// Architecture-only stub. Renders the same empty placeholder as the admin
// variant; will diverge once the corporate student topbar UX lands.
export default {
    name: 'CorporateStudentTopbarLinks',
};
</script>
